import { Injectable } from '@angular/core';
import { ApiModel } from 'app/shared/models/api.model';

import { restEndpoint } from 'config';
import { ImageResolution } from 'helpers';

@Injectable()
export class DownloadModel {
    constructor(private apiModel: ApiModel) {}

    public async getDownloadUrl(partialDownloadRequest: Partial<DownloadRequest>, size: ImageResolution) {
        const { images, video, ...downloadRequest } = partialDownloadRequest;
        const { downloadId } = await this.apiModel.makeHttpRequest({
            method: 'POST',
            url: `${this.apiModel.getDownloadsEndpoint()}/request`,
            body: {
                ...this.mapToCompleteDownloadRequest(downloadRequest),
                size,
                ...(images !== undefined ? { images } : {}),
                ...(video !== undefined ? { video } : {})
            }
        });
        // A CSV request that produced nothing to download (for example PCS failed) comes back without a download id.
        if (!downloadId && downloadRequest.csv) {
            throw new Error('The CSV request did not create a download');
        }

        return `${restEndpoint}/internal${this.apiModel.getDownloadsEndpoint()}/${downloadId}`;
    }

    private mapToCompleteDownloadRequest({
        productImages,
        marketingFiles,
        logos,
        initiator,
        gtins,
        csv
    }: Partial<DownloadRequest>): DownloadRequest {
        return {
            productImages: productImages || [],
            marketingFiles: marketingFiles || [],
            logos: logos || [],
            initiator,
            ...(gtins ? { gtins } : {}),
            ...(csv ? { csv } : {})
        };
    }
}

export interface DownloadCsvOption {
    include: boolean;
    language?: string;
}

interface DownloadRequest {
    productImages: { gtin: string; fileId: string }[];
    marketingFiles: string[];
    logos: string[];
    initiator: string;
    images?: boolean;
    video?: boolean;
    gtins?: string[];
    csv?: DownloadCsvOption;
}
